export default __webpack_public_path__ + "static/media/team-member-3.33ed7c2b.png";